<script setup>
import { ref, onMounted, computed } from "vue";
import { useFilteredFeedStore } from "../stores/FilteredFeed.js";

const props = defineProps({
	title: {
		type: String,
		required: true,
	},
	taxonomy: {
		type: String,
		required: true,
	},
	items: {
		type: Array,
		required: true,
	},
	inline: {
		type: Boolean,
		required: true,
	},
});

const toggled = ref(false)

const store = useFilteredFeedStore();
</script>

<template>
	<li role="menuitem">
		<ul v-if="inline" class="flex flex-col md:flex-row md:flex-wrap md:justify-center items-start gap-4 md:gap-8 desktop:gap-x-16" role="menu">
			<li v-for="item in items" :id="item.id" role="menuitem">
				<a
					href="#"
					@click.prevent="
						store.updateFilters({
							taxonomy: props.taxonomy,
							term: item.slug,
							name: item.name,
						}),
							(toggled = false)
					"
					:class="{
						'underline decoration-1': store.inFilters(item.slug, props.taxonomy),
					}"
					class="text-xl font-medium flex w-full desktop:inline-flex gap-2 items-center justify-between"
				>
					<span v-html="item.name"></span>
				</a>
			</li>
		</ul>
		<div v-if="!inline" class="w-full md:w-auto relative" role="none">
			<button
				@click.prevent="toggled = !toggled"
				:aria-expanded="toggled"
				:aria-label="'Open submenu for ' + props.title"
				:aria-controls="props.taxonomy + '_submenu'"
				aria-haspopup="true"
				class="flex w-full desktop:inline-flex gap-2 items-center justify-between"
			>
				<span v-html="props.title" class="text-md sm:text-xl font-medium"></span>
				<em v-show="toggled" class="text-lg fas fa-angle-down"></em>
				<em v-show="!toggled" class="text-lg fas fa-angle-up"></em>
			</button>
			<ul
				v-show="toggled"
				class="relative md:absolute bg-purple -mx-4 whitespace-nowrap z-20 drop-shadow-xl flex flex-col divide-y divide-purple-light"
				:id="props.taxonomy + '_submenu'"
				role="menu"
			>
				<li v-for="item in items" :id="item.id" role="menuitem">
					<a
						href="#"
						class="text-md sm:text-xl flex gap-6 px-4 py-2 items-center justify-between"
						:aria-label="store.inFilters(item.slug, props.taxonomy) ? 'Remove ' + item.name + ' filter' : 'Filter by ' + props.title"
						@click.prevent="
							store.updateFilters({
								taxonomy: props.taxonomy,
								term: item.slug,
								name: item.name,
							}),
								(toggled = false)
						"
						><span :class="{ 'underline decoration-1': store.inFilters(item.slug, props.taxonomy) }" v-html="item.name"></span>
						<em v-show="store.inFilters(item.slug, props.taxonomy)" class="text-lg fas fa-times"></em>
					</a>
				</li>
			</ul>
		</div>
	</li>
</template>

<style></style>
